export default __webpack_public_path__ + "img/graph_2_x2.webp";